<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <p [innerHtml]="MessageText"></p>
    <div>Enter note here:</div>
    <!-- <j-mat-richtext id="NoteTextBox" [(ngModel)]="ReturnNote" aria-label="Return note body"></j-mat-richtext> -->
    <mat-form-field appearance="outline" style="width: 100%">
        <textarea matInput id="NoteTextBox" class="NoteTextBox" [(ngModel)]="ReturnNote"
            aria-label="Return Note body" rows="5"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()"
        [disabled]="(ReturnNote === null || ReturnNote === '')">{{OKText}}</button>
</div>